export default "__VITE_ASSET__BgR2iqbA__"